import { translation, formatToReactComponent, TranslatedComponent } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import formatDate from 'src/utils/formatDate';

import ForResume from 'src/pages/ApplicantServicesOrder/components/ResumeAudit/ForResume';

import styles from './index.less';

const TrlKeys = {
    waitingDescription: 'resumes.recommendations.resume_audit.description.2',
};

const WaitingRecommendation: TranslatedComponent = ({ trls }) => {
    const order = useSelectorNonNullable(({ resumeAuditOrder }) => resumeAuditOrder);
    return (
        <>
            <Text>
                {formatToReactComponent(trls[TrlKeys.waitingDescription], {
                    '{0}': formatDate(order.dueDate, 'd MMMM'),
                })}
            </Text>
            <VSpacing base={5} xs={4} />
            <div className={styles.delimeter} />
            <VSpacing base={6} />
            <ForResume {...order.resume} />
        </>
    );
};

export default translation(WaitingRecommendation);
